import { Accordion, Button, Modal, ScrollArea, Stack, Text } from "@mantine/core";
import { TERMS_ACCEPTANCE_COPY, TERMS_VERSION, termsModalTitle, type RoleTerms } from "../constants/platformTerms";

interface Props {
  terms: RoleTerms;
  opened: boolean;
  onClose: () => void;
  version?: string;
  accent?: "violet" | "blue";
}

export function TermsModal({
  terms,
  opened,
  onClose,
  version = TERMS_VERSION,
  accent = "violet",
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title={termsModalTitle(terms)} size="xl" centered>
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          {TERMS_ACCEPTANCE_COPY.versionPrefix} {version}
        </Text>
        <Text size="sm" c="dimmed">
          {terms.intro}
        </Text>
        <ScrollArea.Autosize mah="60vh">
          <Accordion variant="separated" defaultValue={terms.sections[0]?.id}>
            {terms.sections.map((section) => (
              <Accordion.Item key={section.id} value={section.id}>
                <Accordion.Control>
                  <Text fw="var(--axio-font-weight-semibold)">{section.title}</Text>
                </Accordion.Control>
                <Accordion.Panel>
                  <Stack gap="xs">
                    {section.bullets.map((bullet) => (
                      <Text key={bullet} size="sm" c="dimmed" lh="var(--axio-line-height-airy)">
                        • {bullet}
                      </Text>
                    ))}
                  </Stack>
                </Accordion.Panel>
              </Accordion.Item>
            ))}
          </Accordion>
        </ScrollArea.Autosize>
        <Button color={accent} onClick={onClose}>
          {TERMS_ACCEPTANCE_COPY.reviewedCta}
        </Button>
      </Stack>
    </Modal>
  );
}
